module.exports = __webpack_public_path__ + "static/media/FJ.f133cc2d.png";